import { TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { gql, Variables } from 'graphql-request';

import {
  JsonSitecoreItem,
  mapSharedPropertiesToFields,
  SitecoreFieldTypes,
} from '@gn-audio/jss-core';

import { parseHeaderTags } from '../../utils/htmlParser';
import { AppSettingFields, LanguageIsoType, ScriptType } from './appSettings.model';

const appSettingsQuery = gql`
  query ($language: String!, $path: String!) {
    item(path: $path, language: $language) {
      ... on AppSettings {
        selectedLanguagesShared {
          jsonValue
        }
        selectedRegionsShared {
          jsonValue
        }
        topSection {
          value
        }
        topSectionShared {
          value
        }
        bottomSection {
          value
        }
        bottomSectionShared {
          value
        }
        topScripts {
          jsonValue
        }
        topScriptsShared {
          jsonValue
        }
        bottomScripts {
          jsonValue
        }
        bottomScriptsShared {
          jsonValue
        }
      }
    }
  }
`;

type AppSettingsResponse = {
  item: {
    selectedLanguagesShared: JsonSitecoreItem<LanguageIsoType>;
    selectedRegionsShared: JsonSitecoreItem<LanguageIsoType>;

    topSection: TextField;
    topSectionShared: TextField;
    bottomSection: TextField;
    bottomSectionShared: TextField;

    topScripts: JsonSitecoreItem<ScriptType>;
    topScriptsShared: JsonSitecoreItem<ScriptType>;
    bottomScripts: JsonSitecoreItem<ScriptType>;
    bottomScriptsShared: JsonSitecoreItem<ScriptType>;
  };
};

export const fetchAppSettings = async (
  locale: string = 'en',
  appName: 'store' | 'support' | 'blueparrott',
  executeGQLQuery: <T>(query: string, variables: Variables) => Promise<T>
): Promise<AppSettingFields | null> => {
  try {
    const { item } = await executeGQLQuery<AppSettingsResponse>(appSettingsQuery, {
      language: locale,
      path: `/sitecore/content/njord-${appName}/AppSettings`,
    });

    if (!item) {
      return null;
    }
    const settings = mapSharedPropertiesToFields<AppSettingFields>(item as SitecoreFieldTypes);
    settings.topSectionParsed = parseHeaderTags(settings.topSection?.value);
    settings.bottomSectionParsed = parseHeaderTags(settings.bottomSection?.value);
    return settings;
  } catch (error) {
    console.error(`Failed to fetch app settings for locale ${locale}:`, error);
    return null;
  }
};
